import { render } from "./LinkRiders.vue?vue&type=template&id=2d40cd0f&scoped=true"
import script from "./LinkRiders.vue?vue&type=script&lang=js"
export * from "./LinkRiders.vue?vue&type=script&lang=js"

import "./LinkRiders.vue?vue&type=style&index=0&id=2d40cd0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d40cd0f"]])

export default __exports__